module.exports = __webpack_public_path__ + "officialStatic/img/index-product-bg.ad7baf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-bg.png
// module id = DZ4B
// module chunks = 0